import { apiUrl } from "./base";

export type CaseAPI = {
  id: string;
  case_number: string;
  created_at: string;
  updated_at?: string;
  metadata: Record<string, unknown>;
  session_count: number;
};

export async function getCaseById(caseId: string): Promise<CaseAPI> {
  const res = await fetch(apiUrl(`/api/cases/${encodeURIComponent(caseId)}`));
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()) as CaseAPI;
}

export async function updateCaseById(
  caseId: string,
  updates: { metadata?: Record<string, unknown> }
): Promise<CaseAPI> {
  const res = await fetch(apiUrl(`/api/cases/${encodeURIComponent(caseId)}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()) as CaseAPI;
}

